'use strict';

export var fnSetActivePage = function () {
    /*Remove active class to avoid duplicates*/
    $('.nav-item').removeClass('active');
    /*Setting the active class to highlight the current menu selected*/
    $('a[href="' + window.location.href + '"]').closest('.nav-item').not('.logo-admin').addClass('active');
}
